module.exports = __webpack_public_path__ + "img/misson_vision_value_03_2.0815bba5.jpg";